import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Heading from "components/Heading/Heading";
import SectionHero from "components/SectionHero/SectionHero";

import SectionTextImage from "components/SectionTextImages/SectionTextImage";
import rightImg from "images/about-hero-right.png";
import featureRight from "images/finvue/availablemobile.png";
// images
import { BanknotesIcon, ClipboardDocumentCheckIcon, CreditCardIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import BottomCTA from "components/CallToAction/BottomCTA";
import FaqSection from "components/FaqSections/FaqSection";
import FinVuePlans from "components/FinvueComponents/FinVuePlans/FinVuePlans";
import KeyBenefitsSection, { BenefitCard } from "components/services/KeyBenefitsSection";
import invoiceSimplifiedImg from "images/finvue/services/invoice-simplified-bg.jpg";
import payrollSolutionsImg from "images/finvue/services/payment-management.jpg";
import schedulePaymentsImg from "images/finvue/services/schedule-payments-bg.jpg";
import staySecureOnlineImg from "images/finvue/services/stay-secure-online.jpg";
import streamlinedBatchImg from "images/finvue/services/streamlined-batch.jpg";
import servicesBg from "images/new/foreign-exchange-header-bg.png";
import onlineBanking1 from "images/new/online-banking-1.png";
import paymentBlockText2 from "images/new/payment-block-text-2.png";
import oneFeatureCenter from "images/one-section-cards-center.png";
import React from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import StatCard from "./StatCard";

const bankingBenefits: BenefitCard[] = [
  {
    id: 1,
    title: "Dashboard in Real-time overview of all accounts.",
    icon: <BanknotesIcon className="w-8 h-8" />,
  },
  {
    id: 2,
    title: "Quick payment release functionality available.",
    icon: <UserGroupIcon className="w-8 h-8" />,
  },
  {
    id: 3,
    title: "Easy transaction data download for reconciliation.",
    icon: <ClipboardDocumentCheckIcon className="w-8 h-8" />,
  },
  {
    id: 4,
    title: "Delegated authority options for accountants.",
    icon: <CreditCardIcon className="w-8 h-8" />,
  },
];

const statistics = [
  { value: "60", label: "Global Customers" },
  { value: "150", label: "Payment Locations" },
  { value: "3", label: "Offices" },
];

const OnlineBankingPage = () => {
  return (
    <div className={`nc-PageAbout relative`}>
      {/* ======== BG GLASS ======== */}
      <div className="rounded-b-xl">
        <SectionHero
          centerImg={servicesBg}
          className="rounded-b-xl"
          topHeading={<span className="text-white text-xs">Online Banking</span>}
          heading={
            <span className="text-2xl px-4 md:px-0 font-black lg:text-5xl text-slate-50">
              Welcome to Banking That
              <br />
              Fits Your Business
            </span>
          }
          btnTextPrimary="Get started"
          btnPrimaryUrl="/sign-up"
          btnTextSecondary="Contact Sales"
          btnSecondaryUrl="/contact"
          subHeading="Our Online Banking puts your finances at your fingertips."
          subHeadingColor="text-slate-200 px-4"
        />
      </div>

      <section className="relative py-16">
        <div className="container">
          <SectionTextImage
            rightImg={onlineBanking1}
            imageClasses=""
            beforeTitle="Plan smarter"
            title={<h3 className="text-2xl md:text-4xl font-normal">Manage your accounts in real time, release payments with a click, and download transaction data effortlessly.</h3>}
            afterTitle=""
          />
        </div>
      </section>
      <section className="relative py-16">
        <KeyBenefitsSection title="Payment Services" benefits={bankingBenefits} />
      </section>
      <section className="relative py-16">
        <div className="container mx-auto md:max-w-none md:px-0">
          {/* <BackgroundSection /> */}
          <SectionTextImage
            leftImg={paymentBlockText2}
            imageClasses=""
            beforeTitle="Plan smarter"
            title={<h3 className="text-2xl md:text-4xl font-normal">It's not just online banking – it's your personal financial command centre</h3>}
            buttonText="Contact us to find out more"
            buttonLink="/sign-up"
          />
        </div>
      </section>
      <section className="relative ">
        <BottomCTA />
      </section>

      <section>
        <FinVuePlans />
      </section>
    </div>
  );
};

export default OnlineBankingPage;
